import {PaymentInfo} from '@wix/auto_sdk_ecom_current-cart-v-2';
import {Address} from '@wix/auto_sdk_ecom_current-cart';
import {AddressModel} from './Address.model';

export class PaymentInfoModel {
  public currencyCode: string;
  public address: AddressModel;

  constructor(params: PaymentInfoModel) {
    this.currencyCode = params.currencyCode;
    this.address = params.address;
  }

  public static fromCartV1(currencyCode: string, address: Address): PaymentInfoModel {
    return new PaymentInfoModel({currencyCode, address: AddressModel.fromCartV1(address)});
  }

  public static fromCartV2(paymentInfo: PaymentInfo): PaymentInfoModel {
    return new PaymentInfoModel({
      currencyCode: paymentInfo?.currencyCode,
      address: AddressModel.fromCartV2(paymentInfo?.billingAddress),
    });
  }
}
